import { render } from "./QuestionnaireFooter.vue?vue&type=template&id=496bca80&scoped=true&ts=true"
import script from "./QuestionnaireFooter.vue?vue&type=script&lang=ts"
export * from "./QuestionnaireFooter.vue?vue&type=script&lang=ts"

import "./QuestionnaireFooter.vue?vue&type=style&index=0&id=496bca80&scoped=true&lang=css"

import exportComponent from "/app/purple__bee/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-496bca80"]])

export default __exports__